import Button from "@mui/material/Button";
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import type { ModalProps } from "@mui/material/Modal";

import NetworkingClinicCard from "./NetworkClinicCard";
import type { NetworkClinic } from "./NetworkForm/networkFormTypes";
import {
  CloseButtonContainer,
  ModalContent,
} from "../styles/NetworkModalStyles";

export type NetworkModalProps = {
  open: boolean;
  onClose: () => void;
  services: NetworkClinic[];
};

export const NetworkModal = ({
  open,
  onClose,
  services,
}: NetworkModalProps) => {
  const handleModalClose: NonNullable<ModalProps["onClose"]> = () => {
    onClose();
  };

  return (
    <Modal
      aria-labelledby="network-modal-title"
      aria-describedby="network-modal-description"
      open={open}
      onClose={handleModalClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <ModalContent>
          <CloseButtonContainer>
            <Button
              variant="contained"
              fullWidth
              onClick={onClose}
              sx={{
                backgroundColor: "#fd6520",
                "&:hover": {
                  backgroundColor: "#e85a18",
                },
              }}
            >
              Fechar
            </Button>
          </CloseButtonContainer>

          <Grid container marginY={2}>
            {services.length > 0 ? (
              <NetworkingClinicCard data={services} />
            ) : (
              <Typography variant="body1">
                Nenhum prestador encontrado para a consulta.
              </Typography>
            )}
          </Grid>
        </ModalContent>
      </Fade>
    </Modal>
  );
};